export const NAV_DATA = [
  {
    name: 'Home',
    href: '/',
  },
  {
    name: 'Exchange points',
    href: '/point'
  },
  {
    name: 'Contacts',
    href: '/about'
  },
];
